import React, {useCallback} from 'react';
import {View, Text} from 'native-base';
import {useTheme} from 'styled-components/native';
import {
  CaesarsButton,
  useIsDesktop,
} from '@eCommerce/frontend-legacy-shared-library-native';
import Link from './Link';
import {Platform} from 'react-native';

export interface LegalLanguagePopUpProps {}

const LegalLanguagePopUp = () => {
  const theme = useTheme() as any;
  const {tuna, athens, white} = theme.colors;
  const isDesktop = useIsDesktop();

  const titleCopy = 'Important Update';
  const bodyCopy =
    'We have updated the Rules and Regulations for our Caesars Rewards program. In order to log in to your account, please review and accept the new terms.';
  const onAcceptTerms = useCallback(() => {
    if (Platform.OS === 'web') {
      const form = document.querySelector('#acceptTermsForm');
      if (form) {
        (form as HTMLFormElement).submit();
      }
    }
  }, []);
  return (
    <View
      maxWidth={isDesktop ? '400px' : undefined}
      shadow={1}
      borderRadius={isDesktop ? '4px' : undefined}
      backgroundColor={white}
      flex={isDesktop ? undefined : 1}>
      <View
        paddingY={isDesktop ? '8px' : '12px'}
        justifyContent="center"
        alignItems="center"
        borderBottomColor={athens}
        borderBottomWidth="2px">
        <Text fontWeight="bold" color={tuna}>
          Terms & Conditions
        </Text>
      </View>
      <View paddingY={isDesktop ? '32px' : '24px'} paddingX="24px" flex={1}>
        <Text
          fontSize={isDesktop ? 6 : 5}
          fontFamily="heading"
          fontWeight={700}
          color={tuna}
          textTransform="uppercase"
          marginBottom={isDesktop ? '32px' : '24px'}>
          {titleCopy}
        </Text>
        <Text fontFamily="body" fontSize={3} marginBottom="32px">
          {bodyCopy}
        </Text>
        <View justifyContent="center" alignItems="center" paddingBottom="16px">
          <Link
            text="Caesars Rewards Rules"
            href="https://www.caesars.com/myrewards/caesars-rewards-rules-regs"
            isExternal
          />
        </View>
      </View>
      <View paddingY="16px" paddingX={isDesktop ? '24px' : '16px'} shadow={5}>
        <CaesarsButton title="Accept" isFullWidth onPress={onAcceptTerms} />
      </View>
    </View>
  );
};

export default LegalLanguagePopUp;
